export const INSERT_RESOURCE_LIST_SECTION_COMMAND =
  'insertResourceListSectionCommand';
export const UPDATE_RESOURCE_LIST_SECTION_COMMAND =
  'updateResourceListSectionCommand';
export const ResourceSectionSchema = 'resourcesection';

// TODO: @asimkt use this instead of hardcoded values
export const ResourceSectionIdAttr = 'resourcesectionid';
export const ResourceIdsAttr = 'resourceids';
export const ResourceSectionTypeAttr = 'resourcesectiontype';
export const ResourceSectionFilterTypeAttr = 'resourcesectionfiltertype';
export const ResourceSectionFilterRangeAttr = 'resourcesectionfilterrange';
